import { CdkTableModule } from '@angular/cdk/table';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatSortModule } from '@angular/material/sort';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FuseSharedModule } from '@fuse/shared.module';
import { CadModelMaterialsMatchingComponent } from './cadmodel-materials-matching.component';
import { CadModelMaterialsMatchingService } from './cadmodel-materials-matching.service';
import { MatBaseSlotsDialogComponent } from './mat-base-slots-dialog/mat-base-slots-dialog.component';

@NgModule({
  imports: [
    MatTableModule,
    CdkTableModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatToolbarModule,
    MatDividerModule,
    MatTabsModule,
    MatCheckboxModule,
    MatSortModule,
    MatTooltipModule,

    FuseSharedModule,
  ],
  exports: [CadModelMaterialsMatchingComponent],
  declarations: [CadModelMaterialsMatchingComponent, MatBaseSlotsDialogComponent],
  providers: [CadModelMaterialsMatchingService],
})
export class CadModelMaterialsMatchingModule {}
